import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import ProgressBar from '../../ProgressBar'
import rate from '../rate'
import RatingStar from '../RatingStar'

import styles from './index.css'

const renderRow = (index, vote, totalVotes) => {
  const percent = Math.round((vote / totalVotes) * 100)

  return (
    <div className={styles.row}>
      <b>{index}</b>
      <span>
        <ProgressBar className={styles.progressBar} value={percent} />
      </span>
      <div>{percent}%</div>
    </div>
  )
}

class RatingDetail extends PureComponent {
  render() {
    const { className, total1, total2, total3, total4, total5, ...props } = this.props

    const totalVotes = total1 + total2 + total3 + total4 + total5
    const rating = rate(total1, total2, total3, total4, total5)

    return (
      <div className={className} {...props}>
        <RatingStar disabled onRate={Function.prototype} value={rating} votes={<b>{rating} de 5</b>} />
        <div className={styles.totalVotes}>
          {totalVotes}
          {totalVotes === 1 ? ' calificación' : ' calificaciones'}
        </div>
        {totalVotes > 0 && (
          <div className={styles.wrapperDetailBar}>
            {renderRow(5, total5, totalVotes)}
            {renderRow(4, total4, totalVotes)}
            {renderRow(3, total3, totalVotes)}
            {renderRow(2, total2, totalVotes)}
            {renderRow(1, total1, totalVotes)}
          </div>
        )}
      </div>
    )
  }
}

RatingDetail.propTypes = {
  className: PropTypes.string,
  total1: PropTypes.number,
  total2: PropTypes.number,
  total3: PropTypes.number,
  total4: PropTypes.number,
  total5: PropTypes.number,
}

RatingDetail.defaultProps = {
  className: null,
  total1: 0,
  total2: 0,
  total3: 0,
  total4: 0,
  total5: 0,
}

export default RatingDetail
